import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { reminderFlowsActions } from 'features/reminderFlows';

const useReminderFlows = () => {
  const dispatch = useDispatch();
  const getReminderFlow = useCallback(() => dispatch(reminderFlowsActions.getReminderFlow()), [dispatch]);
  const createReminderFlow = useCallback(reminder_flow => dispatch(reminderFlowsActions.createReminderFlow(reminder_flow)), [dispatch]);
  const updateReminderFlow = useCallback(reminder_flow => dispatch(reminderFlowsActions.updateReminderFlow(reminder_flow)), [dispatch]);
  const deleteReminderFlow = useCallback(() => dispatch(reminderFlowsActions.deleteReminderFlow()), [dispatch]);
  const clearLocalActiveReminderFlow = useCallback(() => dispatch(reminderFlowsActions.clearLocalActiveReminderFlow()), [dispatch]);

  return {
    getReminderFlow,
    createReminderFlow,
    updateReminderFlow,
    deleteReminderFlow,
    clearLocalActiveReminderFlow
  };
};

export default useReminderFlows;